// 261023 E3-P3ka → 3k-c (User 26/10 «thông tin hiện đủ, ít phải mở») — dải trên cùng: MỘT câu + MỘT nút đỏ + nút phụ hay dùng cạnh nó + tối đa 3 mục chữ hiện thẳng + «⋯» việc hiếm dùng. THUẦN, không antd/react; `NewStoryRunBar.tsx` chỉ vẽ kết quả.
// QUY TẮC ĐỊNH TUYẾN (cho mọi lát sau — vd 3j2b-2 thêm nút «Để máy sửa N tập»):
//   · bar.primary   ⇒ nút đỏ DUY NHẤT của dải (không đổi);
//   · bar.secondary + «Mở sổ duyệt» ⇒ NÚT THƯỜNG cạnh nút đỏ (`buttons`; «Dừng chuỗi» KHÔNG BAO GIỜ danger, đứng cuối). `WbButton` hạ mọi nút không phải CTA về trung tính ⇒ vẫn một nút đỏ;
//   · «⋯» (`menu`) CHỈ còn việc hiếm: «Bắt đầu với cài đặt khác…» (`customStart`) và «Ẩn dải này» (`dismiss`);
//   · bar.lines / callsLine / mục ✓ ! của «Kiểm trước…» / «Máy đã tự sửa N chỗ» ⇒ `bandItemsOf`: CHỈ lý do chặn + lưu ý hiện thẳng, tối đa `BAND_ITEM_CAP` (2) dòng; mục thông tin gộp «và n mục khác» (mở tại chỗ). Mỗi phần tử là MỘT mục;
//     ChainLoop («Chấm → Sửa → Chấm lại») KHÔNG tính vào các mục — khối tiến độ riêng (SA lượt 2, NOTE 5);
//   · lý do CHẶN (lý do khoá nút chính, mục ✗ của «Kiểm trước…», lý do máy chưa chốt dàn tập) đứng đầu và KHÔNG BAO GIỜ bị cắt, dù nhiều hơn 2.
// Không đổi `newStoryBar` / `barBody` (lát 3j0 có thể đang sửa); chỉ đọc kết quả của chúng. Mọi chuỗi động đi qua `redactMoney`. KHÔNG hiện «lần k/3».
import type { WorkbenchEpisode } from '../../../types/adaptationWorkbench';
import { isPushable } from './handoffBatchView';
import { pushBlockedOf } from './episodeRowView';
import { GATE_BLOCKED_LINE } from './chainGateView';
import type { PushStrip } from './handoffBatchView';
import { redactMoney } from './moneyRedact';
import { DONE_WAIT_LINE, DONE_WAIT_LINE_LEGACY, PLAN_STOP_REASON_TEXT, planStopReasonLines } from './newStoryRunView';
import type { NewStoryBar, NsAction, NsKind, NsPhase } from './newStoryRunView';
import type { CkItem, Preflight } from './preflightView';

export const START_SENTENCE = 'Truyện mới — máy sẽ tự làm từ đầu';
export const DISMISS_LABEL = 'Ẩn dải này';
export const CUSTOM_START_LABEL = 'Bắt đầu với cài đặt khác…';
const CANCELLED_SENTENCE = 'Đã dừng chuỗi. Những gì đã làm được giữ nguyên.';
const NS_PREFIX = /^Truyện mới · /;
const AUTOFIX_OLD_LINE = /^Máy tự sửa \d+ tập ở bước viết$/;

export interface BandMenuItem {
  key: string;
  label: string;
  /** Có ⇒ chạy đúng hàm của nút phụ cũ (`run(action)`); vắng ⇒ mục riêng của dải (`customStart` / `dismiss`). */
  action?: NsAction;
  disabled?: boolean;
  reason?: string;
}
export interface BandDetailLine { text: string; warn: boolean; /** «Máy bỏ qua N lỗi…» — bấm mở Sổ duyệt. */ skipped: boolean }
export interface CompactBand {
  kind: NsKind;
  sentence: string;
  tone: NsPhase['tone'];
  /** Lý do CHẶN — luôn hiện ngay dưới câu. */
  blocking: string[];
  /** Tiêu đề khối «Kiểm trước khi …» (các mục ✓ / ! của `detail.checks`). */
  detailTitle: string;
  /** Nguồn của các mục chữ — thứ tự/trần xử lý ở `bandItemsOf`. `chainRows` chỉ để biết có khối ChainLoop hay không (không phải mục). */
  detail: { lines: BandDetailLine[]; checks: CkItem[]; fix: { text: string; episodes: number[] } | null; calls: string | null; chainRows: number };
  /** Nút thường cạnh nút đỏ: mọi nút phụ + «Mở sổ duyệt» (nguy hiểm đứng cuối). */
  buttons: BandMenuItem[];
  /** «⋯»: chỉ việc hiếm dùng (`customStart`, `dismiss`). */
  menu: BandMenuItem[];
}

export type BandItem =
  | { kind: 'blocking'; text: string }
  | { kind: 'line'; text: string; warn: boolean; skipped: boolean }
  | { kind: 'fix'; text: string; episodes: number[] }
  | { kind: 'check'; item: CkItem }
  | { kind: 'calls'; text: string };
/** Trần số mục chữ hiện thẳng ở dải (User 26/10). */
export const BAND_ITEM_CAP = 2;
/** Mảnh «tạo 2 · cập nhật 1» của kế hoạch đẩy (`planLine`) đứng một mình là vô nghĩa — dải gắn tiền tố nói nó là gì. */
export const PUSH_PLAN_PREFIX = 'Khi đẩy sang Chapters: ';
export interface CompactBandCtx {
  episodes: ReadonlyArray<WorkbenchEpisode>;
  push: Pick<PushStrip, 'mode' | 'label' | 'line'> | null;
  reviewVisible: boolean;
  reviewNeed: number;
  /** Tiến độ bước đang chạy (`nsProgressText`), '' nếu không. */
  progress: string;
  autoFix: { places: number; episodes: Array<{ ep: number; places: number }> };
  /** Số hàng «Chấm → Sửa → Chấm lại» (`chain.rows.length`) — chỉ để biết «Chi tiết» có gì không. */
  chainRows: number;
}

const strip = (t: string): string => t.replace(NS_PREFIX, '');
const cap = (t: string): string => (t ? t.charAt(0).toUpperCase() + t.slice(1) : t);
const list = (ns: number[]): string => ns.join(', ');
const LINE_SENTENCE: ReadonlySet<NsKind> = new Set<NsKind>(['interrupted', 'blocked', 'wait_budget', 'wait_review_gate']);
const QUIET_PUSH_MODES: ReadonlySet<string> = new Set(['allPushed', 'running', 'calculating', 'partial']);

interface DoneFacts { written: number; pushed: number; eligible: number; stuck: number[] }
/** BE cũ (không có `eligibleForPush`) ⇒ `isPushable` sai với MỌI tập ⇒ KHÔNG suy «tập bị chặn» (đường đẩy cũ vẫn là nút «Đẩy sang Chapters»). */
const isLegacyPush = (ctx: Pick<CompactBandCtx, 'push'>): boolean => !ctx.push || ctx.push.mode === 'legacy';
const doneFacts = (eps: ReadonlyArray<WorkbenchEpisode>, legacy: boolean): DoneFacts => {
  const written = eps.filter((e) => e.written === 'draft');
  return {
    written: written.length,
    pushed: written.filter((e) => e.handoff === 'up_to_date').length,
    eligible: written.filter((e) => e.handoff !== 'up_to_date' && isPushable(e)).length,
    // CÙNG luật với dòng tập (`episodeRowView.pushBlockedOf`) ⇒ dải nói «chưa đẩy được» thì dòng KHÔNG ra «Đạt».
    stuck: legacy ? [] : written.filter(pushBlockedOf).map((e) => e.ep).sort((a, b) => a - b),
  };
};

const doneSentence = (bar: NewStoryBar, ctx: CompactBandCtx, f: DoneFacts): string => {
  const mode = ctx.push?.mode;
  if (mode === 'running') return ctx.push?.label || strip(bar.title);
  if (f.written === 0) return strip(bar.title);
  if (isLegacyPush(ctx)) return `Xong — viết xong ${f.written} tập, sẵn sàng đẩy`;
  if (mode === 'allPushed') return `Đã đẩy ${f.pushed} tập sang Chapters`;
  if (f.eligible === 0 && f.pushed > 0 && f.stuck.length > 0) return `Đã đẩy ${f.pushed} tập. Tập ${list(f.stuck)} chưa đẩy được`;
  if (f.stuck.length > 0) return f.eligible > 0 ? `Xong ${f.eligible} tập. Tập ${list(f.stuck)} chưa đẩy được nên không đẩy lần này` : `Chưa có tập nào đẩy được — tập ${list(f.stuck)} cần xem`;
  return `Xong — ${f.written} tập đều đạt, sẵn sàng đẩy`;
};

const sentenceOf = (bar: NewStoryBar, ctx: CompactBandCtx, f: DoneFacts): string => {
  switch (bar.kind) {
    case 'none': return '';
    case 'start': return START_SENTENCE;
    case 'start_blocked': return bar.primary?.disabledReason || strip(bar.title);
    case 'cancelled': return CANCELLED_SENTENCE;
    case 'wait_skeleton': return 'Khung xương xong — bạn xem nhanh rồi duyệt';
    case 'running': {
      const n = /(\d)\/3\s*$/.exec(bar.phase.label)?.[1];
      const base = `${n ? `Chặng ${n}/3 · ` : ''}${strip(bar.title)}`;
      return ctx.progress ? `${base} — ${ctx.progress}` : base;
    }
    case 'done': return (bar.primary?.id === 'recheck' || bar.primary?.id === 'autoRepairStart' || bar.secondary.some((a) => a.id === 'autoRepairStop')) && bar.lines[0] ? bar.lines[0] : doneSentence(bar, ctx, f);   // 3j0 (P2) «Cần kiểm lại» · 3j2b-2 «Để máy sửa» / «Máy đang sửa tập n…» — câu của `barBody` là MỘT câu của dải
    case 'wait_plan': return cap(strip(bar.title));
    default: return LINE_SENTENCE.has(bar.kind) && bar.lines[0] ? bar.lines[0] : strip(bar.title);
  }
};

const asItem = (a: NsAction, extra: Partial<BandMenuItem> = {}): BandMenuItem => ({ key: a.id, label: a.label, action: a, ...(a.disabled ? { disabled: true } : {}), ...(a.disabledReason ? { reason: redactMoney(a.disabledReason) } : {}), ...extra });

/** Nút thường cạnh nút đỏ: nút phụ (trừ «Mở sổ duyệt» / «Dừng chuỗi» — xếp riêng cho đúng thứ tự) → «Mở sổ duyệt» → «Dừng chuỗi». */
const buttonsOf = (bar: NewStoryBar, ctx: CompactBandCtx): BandMenuItem[] => {
  if (bar.kind === 'none') return [];
  const out: BandMenuItem[] = [];
  bar.secondary.filter((a) => a.id !== 'cancel' && a.id !== 'openReview').forEach((a) => out.push(asItem(a)));
  if (ctx.reviewVisible || bar.secondary.some((a) => a.id === 'openReview')) {
    out.push({ key: 'openReview', label: ctx.reviewNeed > 0 ? `Mở sổ duyệt · ${ctx.reviewNeed} việc cần bạn` : 'Mở sổ duyệt', action: { id: 'openReview', label: 'Mở sổ duyệt' } });
  }
  const cancel = bar.secondary.find((a) => a.id === 'cancel');
  if (cancel) out.push(asItem(cancel));   // luật 3h1: «Dừng chuỗi» KHÔNG BAO GIỜ danger (nút thường; có hộp xác nhận)
  return out;
};

/** «⋯»: chỉ việc hiếm dùng. */
const menuOf = (bar: NewStoryBar): BandMenuItem[] => {
  if (bar.kind === 'none') return [];
  const out: BandMenuItem[] = [];
  if (bar.kind === 'start') out.push({ key: 'customStart', label: CUSTOM_START_LABEL });
  if (bar.dismissId) out.push({ key: 'dismiss', label: DISMISS_LABEL });
  return out;
};

const uniq = <T,>(xs: T[]): T[] => xs.filter((x, i) => xs.indexOf(x) === i);

export const compactBandOf = (bar: NewStoryBar, pre: Preflight, ctx: CompactBandCtx): CompactBand => {
  const facts = doneFacts(ctx.episodes, isLegacyPush(ctx));
  const sentence = redactMoney(sentenceOf(bar, ctx, facts));

  // Lý do CHẶN: lý do khoá nút chính + mục ✗ của «Kiểm trước…» — không gập.
  const quiet = bar.kind === 'done' && !!ctx.push && QUIET_PUSH_MODES.has(ctx.push.mode);
  // Lý do máy chưa tự chốt dàn tập (nút đỏ «Chốt dàn tập» là một quyết định có hậu quả) và câu «không có nút để lỗi xem sau» của cổng BLOCKED cũng là lý do chặn: không gập.
  const planReasonSet = new Set<string>([...Object.values(PLAN_STOP_REASON_TEXT), ...planStopReasonLines([])]);
  const mustShow = bar.kind === 'wait_plan' ? bar.lines.filter((l) => planReasonSet.has(l)) : bar.kind === 'wait_review_gate' ? bar.lines.filter((l) => l === GATE_BLOCKED_LINE) : [];
  const blocking = uniq([
    ...(bar.primary?.disabled && !quiet && bar.primary.disabledReason ? [bar.primary.disabledReason] : []),
    ...mustShow,
    ...pre.items.filter((i) => i.s === 'bad').map((i) => i.t),
  ].map((t) => redactMoney(t)).filter((t) => t && t !== sentence));

  const checks = pre.items.filter((i) => i.s !== 'bad').map((i) => ({ ...i, t: redactMoney(i.t) }));
  const taken = new Set<string>([sentence, ...blocking, ...pre.items.map((i) => redactMoney(i.t)), DONE_WAIT_LINE, DONE_WAIT_LINE_LEGACY]);
  const planLine = ctx.push?.line ?? '';
  const rawLines = (bar.kind === 'start' ? [bar.title, ...bar.lines] : bar.lines).map((l) => (planLine && l === planLine ? `${PUSH_PLAN_PREFIX}${l}` : l));   // gốc của dòng cụt «tạo 2»: `push.line` đi thẳng vào `bar.lines`
  const lines: BandDetailLine[] = uniq(rawLines.map((l) => redactMoney(l)).filter((l) => l && !taken.has(l) && !AUTOFIX_OLD_LINE.test(l)))
    .map((text) => {
      const skipped = bar.skippedLines.some((s) => redactMoney(s) === text);
      const warn = !skipped && (bar.kind === 'interrupted' || bar.kind === 'wait_plan' || bar.kind === 'wait_budget' || bar.kind === 'blocked' || (bar.kind === 'wait_skeleton' && !!bar.primary?.disabled));
      return { text, warn, skipped };
    });
  const fix = ctx.autoFix.places > 0 ? { text: `Máy đã tự sửa ${ctx.autoFix.places} chỗ ở ${ctx.autoFix.episodes.length} tập`, episodes: ctx.autoFix.episodes.map((e) => e.ep) } : null;
  const calls = bar.callsLine ? redactMoney(bar.callsLine) : null;
  const detail = { lines, checks, fix, calls, chainRows: ctx.chainRows };

  // Tông: «xong, mọi tập đạt» xanh dù còn chờ bạn bấm; còn lại theo `phase.tone`.
  const tone: NsPhase['tone'] = bar.kind === 'done' && bar.primary?.id !== 'recheck' && bar.primary?.id !== 'autoRepairStart' && !bar.secondary.some((a) => a.id === 'autoRepairStop') && facts.written > 0 && facts.stuck.length === 0 && ctx.push?.mode !== 'running' ? 'done' : bar.phase.tone;

  return { kind: bar.kind, sentence, tone, blocking, detailTitle: bar.kind === 'done' ? 'Kiểm trước khi đẩy' : 'Kiểm trước khi bấm', detail, buttons: buttonsOf(bar, ctx), menu: menuOf(bar) };
};

/**
 * Các mục chữ của dải, chia `shown` (hiện thẳng) / `hidden` («và n mục khác»). 3k-c lượt 2 (User: dải quá cao): CHỈ mục CHẶN và LƯU Ý hiện thẳng, tối đa `cap` (2) dòng;
 * mục thông tin (dòng thường · máy đã tự sửa · mục ✓ · gọi dở) luôn gộp vào `hidden`. Lý do CHẶN đứng đầu và KHÔNG BAO GIỜ bị cắt (≥ 3 mục chặn ⇒ hiện hết, mọi mục khác vào `hidden`).
 * Lưu ý = dòng warn · mục «!». Mỗi phần tử là MỘT mục; ChainLoop không phải mục.
 */
export const bandItemsOf = (cb: CompactBand, cap: number = BAND_ITEM_CAP): { shown: BandItem[]; hidden: BandItem[] } => {
  const blocking: BandItem[] = cb.blocking.map((text) => ({ kind: 'blocking', text }));
  const notes: BandItem[] = [
    ...cb.detail.lines.filter((l) => l.warn).map((l): BandItem => ({ kind: 'line', text: l.text, warn: l.warn, skipped: l.skipped })),
    ...cb.detail.checks.filter((c) => c.s !== 'ok').map((item): BandItem => ({ kind: 'check', item })),
  ];
  const info: BandItem[] = [
    ...cb.detail.lines.filter((l) => !l.warn).map((l): BandItem => ({ kind: 'line', text: l.text, warn: l.warn, skipped: l.skipped })),
    ...(cb.detail.fix ? [{ kind: 'fix', text: cb.detail.fix.text, episodes: cb.detail.fix.episodes } as BandItem] : []),
    ...cb.detail.checks.filter((c) => c.s === 'ok').map((item): BandItem => ({ kind: 'check', item })),
    ...(cb.detail.calls ? [{ kind: 'calls', text: cb.detail.calls } as BandItem] : []),
  ];
  const room = Math.max(0, cap - blocking.length);
  return { shown: [...blocking, ...notes.slice(0, room)], hidden: [...notes.slice(room), ...info] };
};
